import { render, staticRenderFns } from "./putASingleRule.vue?vue&type=template&id=6feb363b&"
import script from "./putASingleRule.vue?vue&type=script&lang=js&"
export * from "./putASingleRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6feb363b')) {
      api.createRecord('6feb363b', component.options)
    } else {
      api.reload('6feb363b', component.options)
    }
    module.hot.accept("./putASingleRule.vue?vue&type=template&id=6feb363b&", function () {
      api.rerender('6feb363b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/putASingleRule.vue"
export default component.exports